import React from 'react';

export enum ABodySize {
  XS = 'XS',
  S = 'S',
  M = 'M',
}

export enum ABodyColor {
  Default = 'Default',
  Alternate = 'Alternate',
}
export enum ABodyDecoration {
  Underline = 'underline',
}

export interface ABodyProps extends React.HTMLAttributes<HTMLParagraphElement | HTMLDivElement> {
  bodyText: string;
  size?: ABodySize;
  color?: ABodyColor;
  decoration?: ABodyDecoration;
}
